export default __webpack_public_path__ + "static/media/DeveloperSupport_general_cloud_support_process_incident.41d0b99e.png";